<div class="header-divisor-root flex flex-row flex-wrap justify-between items-start mb-6 w-full min-h-11 gap-2">
    <div class="section-wrapper gap-2 flex-1">
        <div class="header-container pt-2 flex flex-wrap justify-between items-center w-full relative gap-2">
            <div class="flex flex-col min-w-0">
                <div class="flex items-center">
                    <i class="{{ icon() || 'pi pi-bookmark' }} mr-2 flex-0"></i>
                    <h4 class="mt-0 mb-0 p-0 section-title">{{ label() }}</h4>
                </div>

                @if (description() && description().length > 0) {
                    <div class="text-sm text-muted-color flex-3">{{ description() }}</div>
                }
            </div>
            <div class="flex items-center gap-2 flex-wrap">
                @if (onAction.observed) {
                    <button (click)="onAction.emit()" class="btn-text-action flex-auto">Ver mais <i class="pi pi-angle-right ml-1"></i></button>
                }
                @if (useEditButton()) {
                    @if (!modoEdicao()) {
                        <button type="button" class="btn-text-action flex-auto" [disabled]="disableEdit()" (click)="editar.emit()"><i class="pi pi-pencil mr-1"></i>Editar</button>
                    } @else {
                        <button type="button" class="btn-text-action flex-auto" (click)="cancelar.emit()"><i class="pi pi-times mr-1"></i>Cancelar</button>
                        <button type="button" class="btn-text-action flex-auto" [disabled]="loading()" (click)="salvar.emit()"><i class="pi pi-check mr-1"></i>Salvar</button>
                    }
                }
                <div class="flex-0 inline-flex items-start gap-2 relative z-100">
                    <ng-content select="first-action-button"></ng-content>
                    <ng-content select="second-action-button"></ng-content>
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>
